import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { INDUSTRIES } from '../data/mock';

const Industries = () => {
  return (
    <section className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl text-center leading-tight">
          Built For Fast <span className="gradient-text">Moving Businesses</span>
        </h2>
        <p className="mt-5 text-center text-white/55 max-w-2xl mx-auto">
          From bootstrapped Bengaluru startups to Mumbai-based agencies—our infrastructure scales with you.
        </p>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {INDUSTRIES.map((ind) => (
            <Link
              to="/industries"
              key={ind.title}
              className="card-tech rounded-2xl p-5 group block"
            >
              <h3 className="font-display font-semibold text-2xl text-white">{ind.title}</h3>
              <p className="mt-1 text-white/55 text-sm">{ind.tagline}</p>
              <div className="mt-5 relative aspect-[4/3] rounded-lg overflow-hidden border border-[#1AB6FF]/15">
                <img
                  src={ind.image}
                  alt={ind.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#04070d] via-transparent to-transparent" />
                <div className="absolute bottom-3 right-3 w-9 h-9 rounded-full bg-[#04070d]/80 backdrop-blur border border-[#1AB6FF]/40 flex items-center justify-center text-[#1AB6FF] group-hover:bg-[#1AB6FF] group-hover:text-[#04070d] transition-colors">
                  <ArrowRight size={16} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
